"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect, useState } from "react";
import { cn } from "@/lib/utils";
interface ScrollToTopButtonProps {
  onScrollToTop?: () => void;
  targetRef?: RefObject<HTMLElement | null> | undefined;
}
export function ScrollToTopButton(t0) {
  const $ = _c(11);
  const {
    onScrollToTop,
    targetRef
  } = t0;
  const [isVisible, setIsVisible] = useState(false);
  let t1;
  let t2;
  if ($[0] !== targetRef) {
    t1 = () => {
      if (targetRef?.current !== null && targetRef?.current !== undefined) {
        const element = targetRef.current;
        const checkVisibility = () => {
          const rect = element.getBoundingClientRect();
          const isAboveViewport = rect.bottom < 0;
          setIsVisible(isAboveViewport);
        };
        checkVisibility();
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          if (entry !== undefined) {
            const isAboveViewport_0 = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            setIsVisible(isAboveViewport_0);
          }
        }, {
          threshold: 0,
          rootMargin: "0px"
        });
        observer.observe(element);
        window.addEventListener("scroll", checkVisibility, {
          passive: true
        });
        return () => {
          observer.disconnect();
          window.removeEventListener("scroll", checkVisibility);
        };
      }
      const toggleVisibility = () => {
        if (window.scrollY > 300) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };
      window.addEventListener("scroll", toggleVisibility, {
        passive: true
      });
      return () => {
        window.removeEventListener("scroll", toggleVisibility);
      };
    };
    t2 = [targetRef];
    $[0] = targetRef;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onScrollToTop) {
    t3 = () => {
      if (onScrollToTop !== undefined) {
        onScrollToTop();
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    $[3] = onScrollToTop;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClick = t3;
  const t4 = isVisible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-16 opacity-0";
  let t5;
  if ($[5] !== t4) {
    t5 = cn("bg-brand-orange focus:ring-brand-grey fixed right-6 bottom-6 z-50 rounded-full p-3 text-white shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl focus:ring-2 focus:ring-offset-2 focus:outline-none", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Arrow pointing up"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" /></svg>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== handleClick || $[9] !== t5) {
    t7 = <button type="button" onClick={handleClick} className={t5} aria-label="Scroll to top">{t6}</button>;
    $[8] = handleClick;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}